import { SystemsByServiceTypeDetail, DataSystemDetails } from '@ketch-com/windlass/dist/dataSentry/v1/systems/systems'
import { PieChartDataItem, PieChartSubCategory } from '../components/DataPieChart'
import { colorPalette } from './helpers'

export const transformSystemsByServiceType = (
  serviceTypes: SystemsByServiceTypeDetail[] | undefined,
): PieChartDataItem[] => {
  if (!serviceTypes?.length) {
    return []
  }

  const TOP_CATEGORIES_COUNT = 5

  // Calculate total and process valid entries
  const { total, processed } = serviceTypes.reduce(
    (acc, item) => {
      if (!item.serviceType || !item.dataSystemCount) {
        return acc
      }

      const count = item.dataSystemCount
      acc.total += count

      acc.processed.push({
        name: item.serviceType,
        count,
        dataSystems: item.dataSystems ?? [],
      })

      return acc
    },
    { total: 0, processed: [] as Array<{ name: string; count: number; dataSystems: DataSystemDetails[] }> },
  )

  if (total === 0) {
    return []
  }

  // Sort by count descending
  const sorted = processed.sort((a, b) => b.count - a.count)

  const mainCategories: PieChartDataItem[] = []
  const othersGroup: typeof processed = []

  sorted.forEach((item, index) => {
    if (index < TOP_CATEGORIES_COUNT) {
      mainCategories.push({
        name: item.name,
        value: Number(((item.count / total) * 100).toFixed(1)),
        color: colorPalette[index % colorPalette.length],
        originalCount: item.count,
      })
    } else {
      othersGroup.push(item)
    }
  })

  if (othersGroup.length > 0) {
    const othersTotal = othersGroup.reduce((sum, item) => sum + item.count, 0)
    const othersPercentage = Number(((othersTotal / total) * 100).toFixed(1))

    const subCategories: PieChartSubCategory[] = othersGroup.map(item => ({
      name: item.name,
      count: item.count,
      percentage: Number(((item.count / total) * 100).toFixed(1)),
    }))

    mainCategories.push({
      name: 'Others',
      value: othersPercentage,
      color: colorPalette[mainCategories.length % colorPalette.length],
      originalCount: othersTotal,
      subCategories, // Added this line
    })
  }

  return mainCategories
}
